import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';

function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel' }) {
  if (!open) return null;

  return (
    <div style={overlayStyle}>
      <div style={dialogStyle}>
        {title && <h3 style={{ margin: '0 0 12px' }}>{title}</h3>}
        {message && <p style={{ margin: '0 0 20px', color: '#333' }}>{message}</p>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button variant="outline" size="$sm" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const dialogStyle = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '320px',
  maxWidth: '480px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
};

export default ConfirmDialog;
